
  var _styles = {
  "package-prize-modal-content-wrap": {
    "width": "9.13333rem",
    "height": "7.36rem",
    "marginLeft": "0.4rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "package-prize-modal-content": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "100%",
    "height": "100%",
    "position": "relative"
  },
  "package-prize-modal-header": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "100%",
    "marginBottom": "0.42667rem"
  },
  "package-prize-modal-title": {
    "fontSize": "0.42667rem",
    "fontWeight": "500",
    "color": "rgb(64,21,2)",
    "lineHeight": "0.50667rem",
    "fontFamily": "PingFang SC",
    "textAlign": "center",
    "marginTop": "0.74667rem",
    "marginLeft": "-0.34667rem"
  },
  "package-prize-modal-desc": {
    "fontSize": "0.32rem",
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "lineHeight": "0.48rem",
    "fontFamily": "PingFang SC",
    "marginBottom": "0.10667rem",
    "marginTop": "3.09333rem",
    "maxWidth": "100%"
  },
  "package-prize-modal-card": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "100%",
    "marginBottom": "0.42667rem"
  },
  "package-prize-modal-action-btn": {
    "cursor": "pointer"
  },
  "package-prize-modal-close-btn": {
    "cursor": "pointer"
  },
  "package-prize-modal-content-inner": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "zIndex": 1,
    "width": "6.81333rem",
    "height": "7.36rem"
  }
};



  module.exports = _styles;
  